
import { Component, Emit } from 'vue-property-decorator';
import LandingCreateForm from './create.vue';
import { Send } from '@/components/form-base';
import { pick } from 'lodash';
import reportUtils from '@/views/reports/report-utils';
import ApiServices from '@/services';

@Component
export default class Edit extends LandingCreateForm {
  child: boolean = true;

  reportUtils = reportUtils(this);

  get modalTitle(){
    return this.t('Edit Landing')
  }

  async load() {
    this.landing_id = this.data.id || this.$store.getters.selectedItem.id;

    await this.landingApi.get(this.landing_id).then((data: any) => {
      this.form = pick(data, [
        'countryId',
        'name',
        'offers',
        'status',
        'tags',
        'url',
        'workspaceId',
        'created',
        'updated',
        'updatedBy',
      ]);
    });
  }

  loadData() {
    this.edit = true;

    this.landing_id = this.data.id;
    this.$store.commit('loading', true);
    return this.load()
      .then((data: any) => {
        this.show = true;
        this.oldHash = this.getCurrentHash();
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
  }

  @Send()
  submit() {
    this.$store.commit('loading', true);

    this.emptyUrlSend = !this.form.url;

    return this.landingApi.putUpdate(this.landing_id, this.processForm(this.form))
      .then(async (data: any) => {
        await ApiServices.getUserProfile();
        const { id } = data;

        this.oldHash = this.getCurrentHash();

        this.reportUtils.updateName('landings', id);

        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Landing has been changed'));

        this.data?.onEdit?.(data)
        
        this.close();
      })
      .finally(() => this.$store.commit('loading', false));
  }

}
